var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      !_vm.sendSuccess
        ? _c(
            "span",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-md-center my-4 text-center" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("p", [
                      _vm._v(
                        " Les fichiers ont été générés. Si vous quittez maintenant, vous pouvez les retrouver sur la page des reçus fiscaux. "
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        " Les reçus fiscaux seront envoyés depuis l'adresse suivante : "
                      ),
                      _c("b", [_vm._v(_vm._s(_vm.user.email))]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "justify-content-md-center text-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "4", md: "5", sm: "6", xl: "3" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: {
                            variant: "success",
                            title:
                              "Un reçu fiscal au hasard sera envoyé dans votre boite mail",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.testEmail()
                            },
                          },
                        },
                        [_vm._v("Effectuer un test")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "justify-content-md-center text-center mt-2" },
                [
                  !_vm.sendSuccess
                    ? _c(
                        "b-button",
                        {
                          staticClass: "my-2",
                          attrs: { variant: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.sendAllRecus()
                            },
                          },
                        },
                        [_vm._v(" Envoi de tous les reçus fiscaux ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "b-row",
            { staticClass: "justify-content-md-center text-center" },
            [
              _c("h2", { staticClass: "my-2 text-primary" }, [
                _vm._v(
                  " Bravo!!!! L'équipe de l'application souhaite une bonne déclaration à vos adhérents "
                ),
              ]),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }